const maps = document.querySelectorAll('.states-map svg');

for (const svg of maps) {
  const tooltip = document.createElement('div');
  tooltip.className = 'states-tooltip';
  tooltip.setAttribute('aria-hidden', 'true');
  svg.parentElement.append(tooltip);

  for (const path of svg.querySelectorAll('.state')) {
    path.addEventListener('mouseenter', () => {
      const name     = path.getAttribute('data-name') || path.getAttribute('id');
      const isActive = path.classList.contains('active');

      tooltip.innerHTML = `<span class="states-tooltip__name">${name}</span>`;
      tooltip.classList.toggle('is-active', isActive);
      tooltip.classList.add('is-visible');
    });

    path.addEventListener('mousemove', (e) => {
      const rect = svg.parentElement.getBoundingClientRect();
      tooltip.style.left = `${e.clientX - rect.left}px`;
      tooltip.style.top  = `${e.clientY - rect.top}px`;
    });

    path.addEventListener('mouseleave', () => {
      tooltip.classList.remove('is-visible');
    });
  }
}
